﻿/* ------------------------------------------------------------------
   A demó (forras/jaratlap-demo.html) stíluslapja, változatlanul átemelve.

   A megbízás szerint a felület nézzen ki és viselkedjen ugyanúgy, mint a
   prototípus — ezért ez a fájl a referencia. Ne írjuk át kozmetikai okból;
   ha valami hiányzik, inkább külön fájlban egészítsük ki.
   ------------------------------------------------------------------ */

:root{
  --paper:#F7F7F4;--panel:#fff;--ink:#14171A;--muted:#5A6169;--ghost:#A0A6AC;
  --rule:#E4E5E1;--rule2:#CBCDC8;--blue:#1C4C63;--bluew:#E7EFF2;
  --ok:#1A7A56;--okw:#E7F3EE;--bad:#A8281F;--badw:#FBEBEA;--flag:#8A5A00;--flagw:#FBF2E1;
  --star:#A87400;
  --mono:ui-monospace,SFMono-Regular,Menlo,Consolas,monospace;
  --sans:ui-sans-serif,system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;
}
*{box-sizing:border-box}
body{margin:0;background:var(--paper);color:var(--ink);font-family:var(--sans);font-size:13px;
  line-height:1.45;-webkit-font-smoothing:antialiased}
.side2{position:fixed;top:0;left:0;bottom:0;width:180px;background:#16232A;
  display:flex;flex-direction:column;padding:0 0 14px;z-index:30;overflow-y:auto}
.brand2{font-size:11.5px;font-weight:650;letter-spacing:.16em;text-transform:uppercase;
  color:#fff;padding:20px 16px 16px;display:flex;align-items:center;gap:9px;
  border-bottom:1px solid rgba(255,255,255,.09)}
.brand2:before{content:"";width:9px;height:9px;background:#7FB8CE;flex:none;
  box-shadow:3px 3px 0 0 var(--star)}
.tab{appearance:none;background:none;border:0;color:#9FA9B0;font:inherit;font-size:13px;
  padding:9px 16px;cursor:pointer;text-align:left;width:100%;border-left:3px solid transparent;
  line-height:1.35;transition:color .1s,background .1s}
.tab:first-of-type{margin-top:10px}
.tab:hover{background:rgba(255,255,255,.05);color:#fff}
.tab.on{background:rgba(255,255,255,.09);border-left-color:#7FB8CE;color:#fff;font-weight:650}
.tab:disabled{color:#5A646B;cursor:not-allowed;background:none}
.nfoot{margin-top:auto;padding:14px 16px 0;border-top:1px solid rgba(255,255,255,.09)}
.wrap{max-width:1480px;margin:0 0 0 178px;padding:18px 22px 60px}
.pane{display:none}.pane.on{display:block}
.dayhead{display:flex;align-items:center;gap:16px;flex-wrap:wrap;padding-bottom:13px;
  border-bottom:1.5px solid var(--ink)}
.dayhead select{font:inherit;font-size:14px;font-weight:600;padding:6px 10px;border:1px solid var(--rule2);background:#fff}
.hetjel{font-size:11.5px;color:var(--muted)}.hetjel b{color:var(--ink)}
.stats{margin-left:auto;display:flex;gap:18px}
.stats div{font-size:10px;color:var(--muted);text-transform:uppercase;letter-spacing:.06em}
.stats strong{display:block;font-family:var(--mono);font-size:15px;color:var(--ink);
  text-transform:none;letter-spacing:-.01em;margin-top:2px;font-weight:600}
.drv{display:flex;border-bottom:1px solid var(--rule);margin:12px 0 14px;flex-wrap:wrap}
.drv button{appearance:none;background:none;border:0;border-bottom:2px solid transparent;font:inherit;font-size:12.5px;padding:9px 14px;cursor:pointer;color:var(--muted);display:flex;align-items:center;gap:7px}
.drv button:hover{color:var(--ink)}
.drv button.on{color:var(--ink);font-weight:650;border-bottom-color:var(--blue)}
.drv .cnt{font-family:var(--mono);font-size:11px;color:var(--ghost)}
.drv button.on .cnt{color:var(--blue)}
.drv button.sumtab{margin-left:auto;font-weight:600}
.dot{width:7px;height:7px;border-radius:50%;background:#D6D8D4}
.dot.done{background:var(--ok)}.dot.act{background:var(--flag)}
.split{display:grid;grid-template-columns:300px 1fr;gap:16px;align-items:start}
.side{border:1px solid var(--rule2);background:var(--panel);padding:12px;position:sticky;top:14px}
.lbl{font-size:10px;font-weight:600;letter-spacing:.09em;text-transform:uppercase;color:var(--muted);margin:0 0 8px}
.qi{width:100%;border:1px solid var(--rule2);font:inherit;font-size:13px;padding:7px 9px}
.qi:focus{outline:0;border-color:var(--blue);background:var(--bluew)}
.cnt2{font-size:10.5px;color:var(--ghost);margin-top:6px}
.hits{margin-top:8px;max-height:440px;overflow:auto}
.grp{font-size:9.5px;font-weight:600;letter-spacing:.09em;text-transform:uppercase;color:var(--blue);background:var(--bluew);padding:3px 8px;margin-top:8px}
.hit{border-top:1px solid var(--rule);padding:7px 0;cursor:pointer}
.hit:hover{background:#F6F7F5}
.hit b{display:block;font-weight:550;font-size:12.5px}
.hit .c{color:var(--muted);font-size:11px}
.hit .m{font-family:var(--mono);font-size:11px;color:var(--muted);margin-top:2px}
.tag{display:inline-block;font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.04em;padding:1px 5px;margin:2px 4px 0 0;background:var(--flagw);color:var(--flag)}
.empty{color:var(--ghost);font-size:12px;padding:14px 0;text-align:center}
.addcard{border:1.5px solid var(--blue);background:var(--bluew);padding:11px;margin-top:10px}
.addcard h4{margin:0 0 2px;font-size:13px}
.addcard .c{font-size:11px;color:var(--muted);margin-bottom:9px}
.qgrid{display:grid;grid-template-columns:repeat(3,1fr);gap:7px;margin-bottom:8px}
.qgrid label{font-size:9.5px;text-transform:uppercase;letter-spacing:.06em;color:var(--muted);display:block;margin-bottom:2px}
.qgrid input{width:100%;border:1px solid var(--rule2);font-family:var(--mono);font-size:13px;text-align:right;padding:5px 7px;background:#fff}
.qgrid input:focus{outline:0;border-color:var(--blue)}
.addcard select{width:100%;border:1px solid var(--rule2);font:inherit;font-size:12px;padding:5px 6px;background:#fff;margin-bottom:9px}
.addcard .btns{display:flex;gap:6px;flex-wrap:wrap}
/* címfelvevő kártya: hordó és F+ (javitasok-2.0-teljes.md 2–3.) */
.qgrid.q4{grid-template-columns:repeat(4,1fr)}
.fpchk{display:flex;align-items:center;gap:5px;font-size:12px;margin:0 0 9px;cursor:pointer}
.fpchk input{accent-color:var(--blue);margin:0}
.addcard .fpchk .c{margin:0}
.fpchk.tiltott{opacity:.45;cursor:not-allowed}
/* címkék az étteremnév mellett: kék F+ (kattintható), sárga +N HO */
.fpjel{appearance:none;border:1px solid var(--blue);background:var(--bluew);color:var(--blue);
  font:700 9px/1.35 var(--sans);letter-spacing:.04em;padding:0 4px;margin-left:6px;vertical-align:1px;cursor:pointer}
.fpjel:not(.on){border-color:var(--rule2);background:transparent;color:var(--ghost);font-weight:600}
.fpjel:not(.on):hover:not(:disabled){border-color:var(--blue);color:var(--blue)}
.fpjel:disabled{cursor:default}
.hojel{display:inline-block;border:1px solid #E6CF9C;background:var(--flagw);color:var(--flag);
  font:700 9px/1.35 var(--sans);letter-spacing:.04em;padding:0 4px;margin-left:6px;vertical-align:1px}
/* Egyedi moslékár a név mellett — arany keret (feluleti-javitasok.md 1.) */
.mojel{display:inline-block;border:1px solid var(--star);background:#FBF6EA;color:var(--star);
  font:700 9px/1.35 var(--mono);font-variant-numeric:tabular-nums;padding:0 4px;margin-left:6px;vertical-align:1px;white-space:nowrap}
/* a nyomtatott lapon: +N HO az étteremnév után, keretben, hogy papíron is kitűnjön */
.cl td.et .hoj{font-style:normal;font-weight:700;font-size:.82em;border:1px solid #000;padding:0 3px;margin-left:5px;white-space:nowrap}
/* Állandó cím jelölése a nyomtatott lapon: csillag a név előtt. (2026-10-08) */
.cl td.et .alj{font-style:normal;font-weight:700;margin-right:2px}
.sheet{border:1px solid var(--rule2);background:var(--panel);overflow-x:auto;
  box-shadow:0 1px 0 rgba(20,23,26,.04)}
table{border-collapse:collapse;width:100%;font-size:12.5px}
th{background:#F1F2EF;font-size:9.5px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;color:var(--muted);text-align:left;padding:6px 7px;border-bottom:1px solid var(--rule2);white-space:nowrap}
th.n{text-align:right}th.g{border-left:1px solid var(--rule2)}
th.kan{width:30px;font-size:8.5px;letter-spacing:0}
td{padding:0;border-bottom:1px solid var(--rule);vertical-align:middle}
td.g{border-left:1px solid var(--rule2)}
tr:hover td{background:#FAFBFA}
td.idx{font-family:var(--mono);color:var(--ghost);text-align:right;padding:0 7px;width:30px;font-size:11px}
td.nm{padding:4px 7px;min-width:150px}
td.nm b{font-weight:550;display:block;font-size:12.5px}
td.addr{padding:4px 7px;color:var(--muted);font-size:11px;min-width:145px}
td.note{padding:4px 7px;color:var(--muted);font-size:11px;min-width:66px}
td.hand{background:repeating-linear-gradient(45deg,#F7F8F6,#F7F8F6 3px,#F1F2F0 3px,#F1F2F0 6px);width:30px;min-width:30px}
input.c{width:100%;border:0;background:transparent;font-family:var(--mono);font-size:12.5px;text-align:right;padding:8px 7px;color:var(--ink);border-left:3px solid transparent}
input.c:focus{outline:0;background:var(--bluew);border-left-color:var(--blue)}
input.c::placeholder{color:#D9DBD7}
input.c:disabled{color:var(--muted)}
td.q{position:relative;width:62px}
td.q .terv{position:absolute;top:1px;right:6px;font-family:var(--mono);font-size:9px;color:var(--ghost);pointer-events:none}
td.q.pl input.c{padding-top:12px;padding-bottom:4px}
input.c.diff{background:var(--flagw);border-left-color:var(--flag)}
input.c.diff:focus{background:var(--bluew);border-left-color:var(--blue)}
td.sum{font-family:var(--mono);text-align:right;padding:7px;width:128px;min-width:128px;font-size:13.5px;font-variant-numeric:tabular-nums}
td.sum.z{color:var(--ghost)}
select.p{border:0;background:transparent;font:inherit;font-size:11.5px;padding:7px 4px;width:100%;cursor:pointer}
select.p:focus{outline:0;background:var(--bluew)}
select.p.tr{color:var(--blue);font-weight:600}
select.p.rr{color:var(--star);font-weight:600}
td.act{width:60px;text-align:center;white-space:nowrap}
.xb{border:0;background:none;color:var(--ghost);cursor:pointer;font-size:14px;padding:4px}
.xb:hover{color:var(--bad)}
.star{border:0;background:none;cursor:pointer;font-size:15px;padding:2px 4px;color:#D6D8D4;line-height:1}
.star.on{color:var(--star)}.star:hover{color:var(--star)}
tr.late td.nm b:after{content:"utólag";font-size:8.5px;font-weight:600;text-transform:uppercase;color:var(--flag);background:var(--flagw);padding:1px 4px;margin-left:6px;vertical-align:1px}
tfoot td{padding:7px;font-family:var(--mono);text-align:right;font-weight:650;background:#F1F2EF;border-top:1px solid var(--rule2);font-variant-numeric:tabular-nums}
tfoot td.lab{font-family:var(--sans);text-align:left;font-size:9.5px;letter-spacing:.08em;text-transform:uppercase;color:var(--muted);font-weight:600}
.actbar{display:flex;gap:9px;align-items:center;margin-top:14px;flex-wrap:wrap}
.btn{appearance:none;border:1px solid var(--rule2);background:#fff;font:inherit;font-size:12.5px;padding:8px 15px;cursor:pointer}
.btn:hover{border-color:var(--ink)}
.btn.sm{padding:5px 10px;font-size:11.5px}
.btn.pri{background:var(--blue);color:#fff;border-color:var(--blue);font-weight:600}
.btn.pri:hover{background:#153C4E;border-color:#153C4E}
.btn.gold{background:var(--star);color:#fff;border-color:var(--star);font-weight:600}
.btn:disabled{background:#EEEFEC;color:#A8ADB3;border-color:var(--rule);cursor:not-allowed}
.hint{font-size:11.5px;color:var(--muted)}
.blank{border:1px dashed var(--rule2);padding:34px;text-align:center;color:var(--muted);margin-top:14px}
.warns{margin-top:12px}
.warn{background:var(--flagw);border-left:3px solid var(--flag);padding:8px 11px;font-size:12px;margin-bottom:5px}
.cols{display:grid;grid-template-columns:1.15fr 1fr 1fr;gap:16px;margin-top:18px}
.panel{border:1px solid var(--rule);background:var(--panel);padding:13px 14px;
  box-shadow:0 1px 0 rgba(20,23,26,.04)}
.line{display:grid;grid-template-columns:1fr 92px 84px 20px;gap:6px;margin-bottom:5px;align-items:center}
.line.nopay{grid-template-columns:1fr 92px 20px}
.line select,.line input{border:1px solid var(--rule);font:inherit;font-size:11.5px;padding:4px 6px;background:#fff}
.line input.amt{font-family:var(--mono);text-align:right}
.line input:focus,.line select:focus{outline:0;border-color:var(--blue);background:var(--bluew)}
.line button{border:0;background:none;color:var(--ghost);cursor:pointer;font-size:14px}
.line button:hover{color:var(--bad)}
.kv{display:flex;justify-content:space-between;align-items:baseline;gap:10px;padding:4px 0;border-bottom:1px dotted var(--rule)}
.kv:last-child{border-bottom:0}
.kv span{font-size:11.5px;color:var(--muted)}
.kv b{font-family:var(--mono);font-size:13px;font-weight:600;font-variant-numeric:tabular-nums}
.kv.sub b{color:var(--muted);font-size:12px}
.kv.tot{border-top:1.5px solid var(--ink);border-bottom:0;margin-top:5px;padding-top:7px}
.kv.tot span{color:var(--ink);font-weight:600;text-transform:uppercase;font-size:11.5px}
.kv.tot b{font-size:16px}
.stk{display:grid;grid-template-columns:1fr auto;gap:4px 10px;align-items:center;font-family:var(--mono);font-size:12px}
.stk label{font-family:var(--sans);font-size:11.5px;color:var(--muted)}
.stk .v{text-align:right}.stk .calc{color:var(--blue);font-weight:600}
.stk input{width:82px;border:1px solid var(--rule);font-family:var(--mono);font-size:12px;text-align:right;padding:3px 6px;background:#fff}
.stk input:focus{outline:0;border-color:var(--blue);background:var(--bluew)}
.stk hr{grid-column:1/-1;border:0;border-top:1px solid var(--rule);margin:2px 0}
/* Az ellenőrzés három sorszintje (feluleti-javitasok.md 2.): saját · más sofőré · beosztatlan */
tr.other td{background:#F4F5F3;color:var(--ghost)}
tr.other td.nm b{color:var(--ghost);font-weight:400}
tr.other td:first-child{border-left:3px solid #DDE0DB}
tr.other:hover td{background:#EFF1EE}
tr.mine td{background:var(--bluew)}
tr.mine td:first-child{border-left:3px solid var(--blue)}
tr.mine td.nm b{color:var(--ink);font-weight:650}
tr.mine td.idx{color:var(--blue);font-weight:700}
tr.mine:hover td{background:#DCE8EE}
tr.szabad td:first-child{border-left:3px solid transparent}
tr.szabad td.nm b{color:var(--ink)}
/* A „Sofőr" oszlop: a cím átadása másik sofőrnek (feluleti-javitasok.md 3.) */
td.act.edrv{width:118px;text-align:left;background:#F7F8F5;padding:0 4px}
.edrv-dob{display:flex;align-items:center;gap:3px}
td.act.edrv select{width:84px;border:1px solid var(--rule2);background:#fff;font-size:11.5px;padding:4px 5px;cursor:pointer}
td.act.edrv select:focus{outline:0;border-color:var(--blue);background:var(--bluew)}
td.act.edrv select:disabled{background:#F1F2EF;color:var(--muted);cursor:default}
tr.mine td.act.edrv{background:#DCE8EE}
tr.other td.act.edrv{background:#EFF1EE}
select.p.drvon{color:var(--blue);font-weight:600}
.owner{font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.05em;padding:2px 6px;background:#EDEDF8;color:#534AB7}
.chips{display:flex;gap:9px;align-items:center;flex-wrap:wrap;margin-top:14px}
.chip{display:flex;align-items:center;gap:8px;padding:6px 12px;border:1px solid var(--rule2);background:#F8F9F7;min-width:186px}
.chip .mk{font-family:var(--mono);font-size:13px;font-weight:700;width:13px;text-align:center}
.chip em{font-style:normal;font-size:9.5px;letter-spacing:.08em;text-transform:uppercase;color:var(--muted);font-weight:600;display:block}
.chip b{font-family:var(--mono);font-size:12.5px;font-weight:600}
.chip.ok{background:var(--okw);border-color:#B8DDCD}.chip.ok .mk,.chip.ok b{color:var(--ok)}
.chip.bad{background:var(--badw);border-color:#F0C4C1}.chip.bad .mk,.chip.bad b{color:var(--bad)}
.matrix{border:1px solid var(--rule2);background:#fff;overflow-x:auto;margin-top:14px;
  box-shadow:0 1px 0 rgba(20,23,26,.04)}
.matrix table{font-size:12px}
.matrix td.pn{padding:5px 8px;font-weight:550;white-space:nowrap;border-right:1px solid var(--rule2)}
.matrix td.v{font-family:var(--mono);text-align:right;padding:5px 8px;width:50px}
.matrix td.v.z{color:#E4E6E2}
.matrix td.v.new{background:var(--okw);color:var(--ok);font-weight:600}
.matrix td.tt{font-family:var(--mono);text-align:right;padding:5px 8px;font-weight:650;background:#F2F3F1;border-left:1px solid var(--rule2)}
td.sel select,td.sel input{width:100%;border:0;background:transparent;font:inherit;font-size:11.5px;padding:6px 5px}
td.sel select:focus,td.sel input:focus{outline:0;background:var(--bluew)}
table.sumtab td{padding:6px 10px;font-family:var(--mono);text-align:right;font-variant-numeric:tabular-nums}
table.sumtab td.rl{font-family:var(--sans);text-align:left;color:var(--muted);font-size:11.5px}
table.sumtab tr.big td{font-size:15px;font-weight:700;background:#F2F3F1;border-top:1.5px solid var(--ink)}
table.sumtab td.tot{background:#F2F3F1;font-weight:700}
.st{font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.06em;padding:2px 7px}
.st.ok{background:var(--okw);color:var(--ok)}
.st.wait{background:var(--flagw);color:var(--flag)}
#printarea{display:none}
#pv{padding:18px 0;display:flex;flex-direction:column;gap:20px;align-items:center}
.ppage{background:#fff;width:820px;max-width:100%;min-height:1150px;padding:24px 26px;
  box-shadow:0 2px 14px rgba(0,0,0,.14);border:1px solid var(--rule2)}
.ppage .phead{display:flex;align-items:baseline;gap:14px;border-bottom:1.5px solid #000;padding-bottom:4px;margin-bottom:8px}
.ppage .phead h2{font-size:15px;margin:0}
.ppage .phead span{font-size:11px;color:#555}
.ppage .phead .pg{margin-left:auto;font-family:var(--mono)}
.chead{position:relative;margin-bottom:10px;min-height:44px}
.chead .ct{text-align:center;font-size:17px;font-weight:700;padding-top:14px}
.chead .cn{position:absolute;right:0;top:6px;width:210px;text-align:right}
.chead .cn .nl{display:block;border-bottom:1.5px solid #000;height:18px}
.chead .cn em{font-style:normal;font-size:13px}
.chead .cpg{position:absolute;left:0;top:8px;font-family:var(--mono);font-size:10px;color:#666}
table.cl{width:100%;border-collapse:collapse;table-layout:fixed}
table.cl th{border:0;background:none;font-weight:400;font-size:12px;color:#000;padding:2px 3px;
  text-align:center;vertical-align:bottom;text-transform:none;letter-spacing:0;position:static}
table.cl th.sm{font-size:8.5px;line-height:1.1}
table.cl td{border:1px solid #000;height:27px;padding:0 5px;overflow:hidden;white-space:nowrap;
  font-size:13px;vertical-align:middle}
table.cl td.ix{text-align:center;font-size:11px}
table.cl td.et{font-weight:700;font-style:italic}
table.cl td.qq{text-align:center;font-weight:700;font-style:italic}
table.cl td.mn{text-align:center;color:#9AA0A6;font-style:italic}
table.cl td.ar2{text-align:center;font-size:11px;color:#555}
table.cl td.mg{font-size:10px;font-style:italic;text-align:center}
table.cl td.cm{font-size:10.5px;font-style:italic}
table.cl td.fpl,table.cl th.fpl{background:#DDD}
.ppage th,.ppage td{border:1px solid #999;padding:3px 4px;text-align:left}
.ppage th{background:#eee;font-size:8.5px;text-transform:uppercase;letter-spacing:.03em}
.ppage td.e{height:19px;background:#FCFCFA}
.ppage .w1{width:22px}.ppage .w2{width:30px}.ppage .w3{width:32px}
.ppage .w4{width:50px}.ppage .w5{width:130px}.ppage .w6{width:70px}
.ppage table.mini td{font-size:10.5px;padding:5px}
.ppage table.mini td.k{width:96px;color:#333}
.ppage table.mini td.e{height:22px}
.ppage table.mini tr.sum td{font-weight:700;background:#f2f2f2}

.tot4{display:flex;margin:0 0 12px 30%;border-bottom:1.5px solid #000;width:26%;padding-bottom:2px}
.tot4 span{flex:1;text-align:center;font-family:var(--mono);font-size:11px;font-weight:600}
.p2{display:grid;grid-template-columns:42fr 58fr;gap:24px;margin-top:4px;align-items:start;width:100%}
.rblk{display:block;width:100%}
.r2c{display:grid;grid-template-columns:1fr 1fr;gap:22px;align-items:start;width:100%}
.hd2{font-weight:700;font-size:13px;letter-spacing:.02em;border-bottom:2.5px solid #000;
  padding-bottom:2px;margin-bottom:0}
table.bl{width:100%;border-collapse:collapse;table-layout:fixed}
table.bl td{border:0;padding:0;background:#fff}
table.bl td.gl{width:18px;font-size:8px;font-weight:700;vertical-align:bottom;color:#000}
table.bl td.k3{width:50px;font-size:13px;font-weight:700;vertical-align:bottom;white-space:nowrap}
table.bl td.k4{width:72px;font-size:13px;font-weight:700;vertical-align:bottom;white-space:nowrap;
  text-align:right;padding-right:6px}
table.bl td.k5{width:38px;font-size:11px;font-weight:700;vertical-align:bottom;white-space:nowrap}
table.bl td.ln{border-bottom:1.5px solid #000;height:22px;width:auto}
table.bl.sp2 td.ln{height:34px}
.aktitle{text-align:right;font-size:10px;font-weight:700;letter-spacing:.04em;margin:14px 0 2px}
.akbox{border:1px solid #000;padding:8px 12px 5px;width:100%}
table.akt2{width:100%;border-collapse:collapse;table-layout:fixed}
table.akt2 th{font-size:10.5px;font-weight:700;text-align:left;padding:0 4px 6px;border:0;background:none;
  text-transform:none;letter-spacing:0;color:#000;position:static}
table.akt2 th:first-child{width:62px}
table.akt2 td{border:0;padding:0 4px}
table.akt2 td.dn{font-size:11.5px;font-weight:700;white-space:nowrap;padding-right:6px}
table.akt2 td.ac{border-bottom:1.2px solid #000;border-right:1px solid #000;height:26px}
table.akt2 td.ac:last-child{border-right:0}

.pB{display:grid;grid-template-columns:1fr 1fr 1fr;gap:14px;width:100%}
.pB .bx{border:1px solid #000;padding:8px 10px 10px}
.pB .bx.wide2{grid-column:1/-1}
.pB h3{margin:0 0 7px;font-size:10.5px;font-weight:700;letter-spacing:.06em;
  border-bottom:1.5px solid #000;padding-bottom:3px}
.bgrp{margin-bottom:8px}
.bgrp span{font-size:9px;font-weight:700;letter-spacing:.05em;color:#444;text-transform:uppercase}
table.bl.big3 td.k6{width:76px;font-size:10.5px;font-weight:700;vertical-align:bottom}
table.bl.big3 td.ln{height:24px}
table.bl.big3 td.str{border-bottom-width:2.5px}
table.bl.big3 td.k6.str{font-size:12px}
.minisum{margin-top:8px;font-family:var(--mono);font-size:10px;color:#444;text-align:center}
.pC{display:grid;grid-template-columns:1.15fr 1fr;gap:20px;width:100%}
.pC .ch{margin:0 0 5px;font-size:11px;font-weight:700;letter-spacing:.06em;
  border-bottom:2px solid #000;padding-bottom:2px}
table.grid2{width:100%;border-collapse:collapse}
table.grid2 th{font-size:8.5px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;
  background:#f0f0f0;border:1px solid #000;padding:3px 5px;text-align:left;color:#000;position:static}
table.grid2 td{border:1px solid #000;height:23px;padding:0 5px;background:#fff}
table.grid2.kv2 td.k7{width:82px;font-size:10.5px;font-weight:700;background:#f7f7f7}
table.grid2.kv2 tr.str2 td{border-width:2px;height:27px}
table.akt2.bd{border:1px solid #000;padding:0}
table.akt2.bd th{padding:4px 5px;background:#f0f0f0;border:1px solid #000}
table.akt2.bd td{border:1px solid #000;height:23px;padding:0 4px}
table.akt2.bd td.ac{border-bottom:1px solid #000;border-right:1px solid #000}

/* ===== visszapótolt és frissített komponensek ===== */
.cards{display:grid;grid-template-columns:repeat(auto-fit,minmax(158px,1fr));gap:12px;margin-top:16px}
.card{border:1px solid var(--rule);background:var(--panel);padding:12px 14px;
  box-shadow:0 1px 0 rgba(20,23,26,.04)}
.card em{font-style:normal;display:block;font-size:9.5px;font-weight:600;letter-spacing:.08em;
  text-transform:uppercase;color:var(--muted);margin-bottom:3px}
.card b{font-family:var(--mono);font-size:21px;font-weight:600;letter-spacing:-.02em;
  font-variant-numeric:tabular-nums;display:block;margin:1px 0 2px}
.card span{font-size:11px;color:var(--muted)}
.card.warn2{background:var(--flagw);border-color:#E8D9B4;cursor:pointer}
.card.warn2 b{color:var(--flag)}
.sw{display:flex;align-items:center;gap:6px;font-size:12px;color:var(--muted);cursor:pointer}
.sw input{margin:0}
.only{color:var(--star);font-weight:600}
.bad2{color:var(--bad);font-weight:600}
.rdv{font-size:12.5px;padding:5px 0}
.bar{display:block;height:12px;background:var(--blue);opacity:.8;min-width:2px}

/* szűrőcsipek */
.fchips{display:flex;gap:7px;flex-wrap:wrap;margin:16px 0 12px}
.fchip{appearance:none;border:1px solid var(--rule2);background:#fff;font:inherit;font-size:11.5px;
  padding:6px 13px;cursor:pointer;color:var(--muted)}
.fchip:hover{border-color:var(--ink);color:var(--ink)}
.fchip.on{background:var(--blue);color:#fff;border-color:var(--blue);font-weight:600}
.fchip b{font-family:var(--mono);font-weight:600;margin-left:6px;opacity:.7}

/* változatváltó */
.vsw{display:flex;border:1px solid var(--rule2)}
.vsw button{appearance:none;border:0;border-right:1px solid var(--rule2);background:#fff;font:inherit;
  font-size:11.5px;padding:6px 14px;cursor:pointer;color:var(--muted)}
.vsw button:last-child{border-right:0}
.vsw button.on{background:var(--blue);color:#fff;font-weight:600}

/* adattábla — törzsadatok, archívum, karton */
table.tt2{width:100%;border-collapse:separate;border-spacing:0;font-size:13px}
table.tt2 th{position:sticky;top:0;background:var(--panel);font-size:10px;font-weight:600;
  letter-spacing:.07em;text-transform:uppercase;color:var(--muted);text-align:left;
  padding:11px 10px;border-bottom:1.5px solid var(--ink);white-space:nowrap;z-index:2}
table.tt2 th.n{text-align:right}
table.tt2 td{padding:0;border-bottom:1px solid var(--rule);vertical-align:middle;background:#fff}
table.tt2 tbody tr:hover td{background:#FAFAF7}
table.tt2 tbody tr.nul td{background:#FCFCFA}
table.tt2 td.nm3{padding:9px 10px;min-width:200px;cursor:pointer;line-height:1.3}
table.tt2 td.nm3 b{font-weight:600;display:block;font-size:13px}
table.tt2 td.nm3 small{display:block;color:var(--ghost);font-size:10.5px}
table.tt2 td.nm3:hover b{color:var(--blue)}
table.tt2 input{width:100%;border:1px solid transparent;background:transparent;font-family:var(--mono);
  font-size:12.5px;padding:7px 9px;text-align:right;color:var(--ink);transition:background .1s,border-color .1s}
table.tt2 input.txt{font-family:var(--sans);text-align:left}
table.tt2 tbody tr:hover input{background:#fff;border-color:var(--rule)}
table.tt2 input:focus{outline:0;background:var(--bluew);border-color:var(--blue)}
table.tt2 input::placeholder{color:#CDD1CB}
table.tt2 select{border:1px solid transparent;background:transparent;font:inherit;font-size:12px;
  padding:6px;width:100%;color:var(--muted);cursor:pointer}
table.tt2 tbody tr:hover select{background:#fff;border-color:var(--rule)}
table.tt2 select:focus{outline:0;background:var(--bluew);border-color:var(--blue);color:var(--ink)}
table.tt2 td.calc2{font-family:var(--mono);text-align:right;padding:9px 10px;color:var(--muted);
  font-variant-numeric:tabular-nums}
table.tt2 td.act{width:46px;text-align:center}
table.tt2 tr.gyr td.nm3 b{color:var(--star)}
table.tt2 tfoot td{padding:9px 10px;font-family:var(--mono);text-align:right;font-weight:650;
  background:#F1F2EF;border-top:1.5px solid var(--ink)}
table.tt2 tfoot td.dcol{font-family:var(--sans);text-align:left;font-size:10px;
  text-transform:uppercase;letter-spacing:.06em;color:var(--muted)}

/* autókészlet napló */
table.ksT th.carh{text-align:center;cursor:pointer;border-left:1px solid var(--rule2);
  font-size:11.5px;color:var(--ink);font-weight:700;padding:9px 8px}
table.ksT th.carh:hover{background:var(--bluew);color:var(--blue)}
table.ksT th.sub{font-size:8.5px;padding:5px 8px;font-weight:600;border-bottom:1.5px solid var(--ink)}
table.ksT th.dcol,table.ksT td.dcol{border-right:1px solid var(--rule2)}
table.ksT td.dcol{padding:8px 10px;white-space:nowrap;font-size:12.5px}
table.ksT td.zr{font-weight:700;color:var(--ink)}
table.ksT td.pos{color:var(--ok)}
table.ksT td.neg{color:var(--muted)}

/* részletszerkesztő */
.tdet{border:1px solid var(--blue);background:var(--bluew);padding:15px 17px;margin-bottom:13px}
.tdet h4{margin:0 0 11px;font-size:14px}
.tdet .g4{display:grid;grid-template-columns:repeat(4,1fr);gap:11px}
.tdet label{display:block;font-size:9.5px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;
  color:var(--muted);margin-bottom:3px}
.tdet input{width:100%;border:1px solid var(--rule2);font:inherit;font-size:12.5px;padding:6px 8px;background:#fff}
.tdet input:focus{outline:0;border-color:var(--blue)}
.tdet .btns{display:flex;gap:6px;margin-top:13px;align-items:center}

/* új partner űrlap */
.npform{border:1px solid var(--star);background:#FCF8EF;padding:13px;margin-top:10px}
.npform h4{margin:0 0 9px;font-size:13px}
.npform label{display:block;font-size:9.5px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;
  color:var(--muted);margin:8px 0 2px}
.npform input,.npform select{width:100%;border:1px solid var(--rule2);font:inherit;font-size:12.5px;
  padding:6px 8px;background:#fff}
.npform input:focus,.npform select:focus{outline:0;border-color:var(--blue);background:var(--bluew)}
.npform .r2{display:grid;grid-template-columns:1fr 1fr;gap:8px}
.npform .r3{display:grid;grid-template-columns:74px 1fr;gap:8px}
.npform .chk{display:flex;align-items:center;gap:7px;margin-top:10px;font-size:12px}
.npform .chk input{width:auto}
.npform .btns{display:flex;gap:6px;margin-top:12px;flex-wrap:wrap}
.npform .sec{font-size:9.5px;font-weight:600;letter-spacing:.07em;text-transform:uppercase;
  color:var(--star);margin-top:13px;border-top:1px solid #EADFC6;padding-top:9px}

/* import / visszatöltés */
.impbox,.diffbox{border:1px solid var(--blue);background:var(--bluew);padding:15px 17px;margin:14px 0}
.diffbox{border-color:var(--star);background:#FCF8EF}
.impbox h4,.diffbox h4{margin:0 0 4px;font-size:14px}
.impbox .sum2,.diffbox .sum2{display:flex;gap:22px;flex-wrap:wrap;margin:10px 0 12px}
.impbox .sum2 div,.diffbox .sum2 div{font-size:11.5px;color:var(--muted)}
.impbox .sum2 b,.diffbox .sum2 b{display:block;font-family:var(--mono);font-size:19px;color:var(--ink)}
.impbox .sum2 .ok2 b{color:var(--ok)}.impbox .sum2 .ch b{color:var(--flag)}
.diffbox .sum2 .ok2 b{color:var(--ok)}.diffbox .sum2 .ch b{color:var(--flag)}
.pairs,.dfscroll{max-height:310px;overflow:auto;border:1px solid var(--rule2);background:#fff}
table.prt,table.dft{width:100%;border-collapse:collapse;font-size:12px}
table.prt th,table.dft th{background:#F1F2EF;font-size:9.5px;text-transform:uppercase;letter-spacing:.05em;
  color:var(--muted);text-align:left;padding:7px 9px;border-bottom:1px solid var(--rule2);position:sticky;top:0}
table.prt td,table.dft td{padding:6px 9px;border-bottom:1px solid var(--rule);vertical-align:middle;background:#fff}
table.prt td.src{font-weight:600}
table.prt select{width:100%;border:1px solid var(--rule2);font:inherit;font-size:11.5px;padding:4px 6px;background:#fff}
table.prt tr.okrow td.src{color:var(--ok)}
table.prt tr.needs td.src{color:var(--flag)}
table.dft td.old{color:var(--bad);text-decoration:line-through}
table.dft td.new{color:var(--ok);font-weight:600}
table.dft .newrow td{background:var(--okw)}
.impbox .opts{display:flex;gap:18px;align-items:center;margin:12px 0 4px;font-size:12px}
.impbox .opts label{display:flex;gap:6px;align-items:center;cursor:pointer;color:var(--muted)}

/* nem vásárlók lista */
.misslist{border:1px solid var(--rule2);background:var(--panel);padding:13px 15px;margin-top:14px;
  max-height:420px;overflow:auto}
table.nvt{width:100%;border-collapse:collapse;font-size:12px;margin-top:7px}
table.nvt th{background:#F1F2EF;font-size:9.5px;text-transform:uppercase;letter-spacing:.05em;
  color:var(--muted);text-align:left;padding:6px 9px;border-bottom:1px solid var(--rule2)}
table.nvt td{padding:5px 9px;border-bottom:1px solid var(--rule)}
table.nvt td.n{text-align:right;font-family:var(--mono)}

/* rendezősáv */
.sortbar{display:flex;align-items:center;gap:7px;margin-bottom:10px;flex-wrap:wrap}
.sortbar>span:first-child{font-size:10px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;
  color:var(--muted);margin-right:2px}
.sb{appearance:none;border:1px solid var(--rule2);background:#fff;font:inherit;font-size:11.5px;
  padding:5px 12px;cursor:pointer;color:var(--muted)}
.sb:hover{border-color:var(--ink);color:var(--ink)}
.sb.on{background:var(--blue);color:#fff;border-color:var(--blue);font-weight:600}
th.hsort{cursor:pointer;user-select:none}
th.hsort:hover{color:var(--ink)}

/* egyéb */
.line{display:grid;grid-template-columns:1fr 94px 84px 22px;gap:6px;margin-bottom:5px;align-items:center}
.line.nopay{grid-template-columns:1fr 94px 22px}
.katlab{font-size:12px}
.matrix td.pn.grp2{font-weight:700}
.matrix td.pn small{display:block;color:var(--ghost);font-weight:400;font-size:10px}
.matrix td.ftv{font-family:var(--mono);text-align:right;padding:6px 9px;color:var(--muted);
  background:#FAFAF7;border-left:1px solid var(--rule)}
.matrix th.sticky1{position:sticky;left:0;background:var(--panel);z-index:3}
td.pn.kclick{cursor:pointer}
td.pn.kclick:hover{color:var(--blue);text-decoration:underline}
td.sel select,td.sel input{width:100%;border:0;background:transparent;font:inherit;font-size:11.5px;padding:7px 6px}
td.sel select:focus,td.sel input:focus{outline:0;background:var(--bluew)}

@media(max-width:1000px){
  .side2{position:static;width:auto;flex-direction:row;flex-wrap:wrap;align-items:center;padding:0 8px}
  .brand2{padding:10px 14px 10px 6px}
  .tab{width:auto;border-left:0;border-bottom:3px solid transparent;padding:11px 11px}
  .tab.on{border-left:0;border-bottom-color:#7FB8CE}
  .nfoot{margin:0 0 0 auto;padding:0 8px}
  .wrap{margin:0;padding:14px}
}
@media print{
  .side2,.dayhead,.drv,.split,.actbar,.warns,.hint,.cols,.chips,#pv,.sortbar{display:none!important}
  #printarea{display:block!important}
  body{background:#fff;font-size:10px}.wrap{padding:0;margin:0;max-width:none}
  /* Nagyobb betű, szűkebb margó (javitasok-jarattervezes.md 3.):
     41 sor × 6,4 mm = 262 mm, a fejléccel 276 mm — az A4-en 288 mm fér el. */
  @page{size:A4 portrait;margin:5mm 5mm 4mm 5mm}
  .psheet{page-break-after:always;width:100%;padding:0;margin:0}
  /* Az utolsó lap után nincs oldaltörés — különben egy üres lap jönne ki. */
  #printarea>div:last-child>.psheet:last-child{page-break-after:auto}
  .psheet .phead{display:flex;align-items:baseline;gap:12px;border-bottom:1.5px solid #000;padding-bottom:3px;margin-bottom:5px}
  .psheet .phead h2{font-size:14px;margin:0}
  .psheet .phead span{font-size:10.5px;color:#444}
  .psheet .phead .pg{margin-left:auto;font-size:9.5px;color:#666}
  .psheet .chead{position:relative;margin-bottom:5px;min-height:36px}
  .psheet .chead .ct{text-align:center;font-size:16px;font-weight:700;padding-top:9px}
  .psheet .chead .cn{position:absolute;right:0;top:4px;width:170px;text-align:right}
  .psheet .chead .cn .nl{display:block;border-bottom:1.2px solid #000;height:15px}
  .psheet .chead .cn em{font-style:normal;font-size:10.5px}
  .psheet .chead .cpg{position:absolute;left:0;top:6px;font-size:9px;color:#666}
  .psheet table.cl{width:100%;border-collapse:collapse;table-layout:fixed}
  .psheet table.cl th{border:0;background:none;font-weight:400;font-size:10.5px;color:#000;
    padding:1px 2px;text-align:center;vertical-align:bottom;text-transform:none}
  .psheet table.cl th.sm{font-size:8px;line-height:1.1}
  .psheet table.cl td{border:1px solid #000;height:6.4mm;padding:0 3px;overflow:hidden;
    white-space:nowrap;font-size:11.5px;vertical-align:middle}
  .psheet table.cl td.ix{text-align:center;font-size:9.5px}
  .psheet table.cl td.et{font-weight:700;font-style:italic;font-size:11.5px}
  .psheet table.cl td.qq{text-align:center;font-weight:700;font-style:italic;font-size:11.5px}
  .psheet table.cl td.mn{text-align:center;color:#999;font-style:italic;font-size:11.5px}
  .psheet table.cl td.ar2{text-align:center;font-size:10px;color:#555}
  .psheet table.cl td.mg{font-size:9px;font-style:italic;text-align:center}
  .psheet table.cl td.cm{font-size:9.5px;font-style:italic}
  .psheet table.cl td.fpl,.psheet table.cl th.fpl{background:#DDD}
  .psheet th,.psheet td{border:1px solid #888;padding:2px 3px;text-align:left}
  .psheet th{background:#eee;font-size:7.5px;text-transform:uppercase;font-weight:600}
  .psheet td.e{height:16px}
  .psheet .w1{width:16px}.psheet .w2{width:22px}.psheet .w3{width:26px}
  .psheet .w4{width:40px}.psheet .w5{width:112px}.psheet .w6{width:56px}
    .psheet table.bl td.ln{height:17px}
  .psheet table.bl.sp2 td.ln{height:26px}
  .psheet .hd2{font-size:11px}
  .psheet table.bl td.k3{font-size:11px;width:44px}
  .psheet table.bl td.k4{font-size:11px;width:66px}
  .psheet table.bl td.k5{font-size:9.5px;width:34px}
  .psheet table.akt2 th{font-size:8.5px;padding:0 3px 4px}
  .psheet table.akt2 td.dn{font-size:9.5px}
  .psheet table.akt2 td.ac{height:20px}
  .psheet .p2{gap:18px}
  .psheet .r2c{gap:16px}
  .psheet .akbox{padding:6px 9px 4px}
  .psheet .pB{gap:10px}
  .psheet .pB .bx{padding:6px 8px 8px}
  .psheet .pB h3{font-size:9px}
  .psheet table.bl.big3 td.ln{height:19px}
  .psheet table.bl.big3 td.k6{width:62px;font-size:9px}
  .psheet .pC{gap:14px}
  .psheet table.grid2 td{height:18px}
  .psheet table.grid2 th{font-size:7.5px;padding:2px 4px}
  .psheet table.grid2.kv2 td.k7{width:68px;font-size:9px}
  .psheet table.akt2.bd td{height:18px}
}
